import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import moment from 'moment';

import styles from './BoxRow.scss';
import { formatPacificTimeRange } from '../../../helpers/pacificTime';

function RequestorRowItems(props) {
  const { page, item, timesArray } = props;

  const { booking, calendar } = item;
  const itemStatus = booking.status;
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();

  useEffect(() => {
    if (calendar && calendar.times) {
      const startIndex = timesArray.findIndex(x => x.id === calendar.times[2]);
      const endIndex = timesArray.findIndex(
        x => x.id === calendar.times[calendar.times.length - 3],
      );
      startIndex !== -1 ? setStartTime(timesArray[startIndex].label) : null;
      endIndex !== -1 ? setEndTime(timesArray[endIndex].label) : null;
    }
  }, [item]);

  return (
    <div
      className={cx(
        styles.box__row,
        styles[`box__row--${page}`],
        styles[`box__row--${itemStatus.toLowerCase()}`],
      )}
    >
      <div
        className={cx(
          styles.box__row__body,
          styles.box__row__body__3col,
          styles.box__row__body__light,
          styles[`box__row__body--${itemStatus.toLowerCase()}`],
        )}
      >
        <div className={styles.box__row__body__item}>
          <div>Booking ID</div>
          <div>#{booking.tourId}</div>
        </div>
        <div className={styles.box__row__body__item}>
          <div>Group Name</div>
          <div>{item.tourTypeName}</div>
        </div>
        <div className={styles.box__row__body__item}>
          {calendar ? (
            <>
              <div>Date & Time</div>
              <div>
                {moment.monthsShort(calendar.month - 1)} {calendar.day},{' '}
                {calendar.year} - {formatPacificTimeRange(startTime, endTime)}
              </div>
            </>
          ) : (
            <>
              <div>Status</div>
              <div>Denied</div>
            </>
          )}
        </div>
      </div>
      {itemStatus === 'denied' && booking.denyReason ? (
        <div
          className={cx(
            styles.box__row__body,
            styles.box__row__body__text,
            styles[`box__row__body--${itemStatus.toLowerCase()}`],
          )}
        >
          <div className={styles.box__row__body__item__full}>
            <div>Reason</div>
            <div>{booking.denyReason}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default RequestorRowItems;
